function injectStyle (ssrContext) {
  require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-1a71673f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../vue-loader/lib/selector?type=styles&index=0!./map.vue")
}
var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./map.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1a71673f\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../vue-loader/lib/selector?type=template&index=0!./map.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/dist/components/map.vue
// module id = 590
// module chunks = 6